/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = ({
  name: 'LoadingPage'
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-wrapper" }, [
    _c("header", { staticClass: "p-header" }, [
      _c("h1", { staticClass: "is-title-2 p-title" }, [
        _c("img", {
          staticClass: "c-logo",
          attrs: {
            src: "/assets/images/group-income-icon-transparent.png",
            alt: "",
          },
        }),
        _vm._v(_vm._s(_vm.$route.meta.title)),
      ]),
    ]),
    _vm._m(0),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("main", { staticClass: "p-main" }, [
      _c("div", { staticClass: "loading-box" }),
      _c("div", { staticClass: "loading-box" }),
      _c("div", { staticClass: "loading-box" }),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-b4e9b596_0", { source: ".p-wrapper[data-v-b4e9b596] {\n  display: grid;\n  grid-template-areas: \"p-header\" \"p-main\";\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  width: 100vw;\n}\n@media screen and (min-width: 1200px) {\n.p-wrapper[data-v-b4e9b596] {\n    width: auto;\n    grid-template-columns: minmax(0, 1fr) 16.5rem;\n    grid-template-areas: \"p-header p-sidebar\" \"p-main p-sidebar\";\n}\n}\n.p-main[data-v-b4e9b596] {\n  grid-area: p-main;\n  width: calc(100% - 2rem);\n  margin: 0 auto;\n  padding-top: 1.5rem;\n  max-width: 50rem;\n  display: flex;\n  flex-direction: column;\n  -webkit-overflow-scrolling: touch;\n}\n@media screen and (min-width: 769px), print {\n.p-main[data-v-b4e9b596] {\n    width: calc(100% - 4rem);\n}\n}\n@media screen and (min-width: 1200px) {\n.p-main[data-v-b4e9b596] {\n    width: auto;\n    padding-top: 0;\n    margin-right: 2rem;\n    margin-left: 5.5rem;\n}\n}\n.p-header[data-v-b4e9b596] {\n  grid-area: p-header;\n  transition: padding ease-out 300ms;\n  text-align: center;\n  min-height: 4rem;\n}\n@media screen and (max-width: 1199px) {\n.p-header[data-v-b4e9b596] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    background: var(--general_2);\n    z-index: 3;\n}\n}\n@media screen and (min-width: 1200px) {\n.p-header[data-v-b4e9b596] {\n    display: block;\n    padding-top: 1.125rem;\n    text-align: left;\n    min-height: 4.75rem;\n    padding-left: 5.5rem;\n}\n}\n.p-title[data-v-b4e9b596] {\n  display: flex;\n  align-items: center;\n}\n.c-logo[data-v-b4e9b596] {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 1rem;\n}\n@media screen and (min-width: 1200px) {\n.c-logo[data-v-b4e9b596] {\n    display: none;\n}\n}\n\n/*# sourceMappingURL=LoadingPage.vue.map */", map: {"version":3,"sources":["frontend/views/containers/loading-error/LoadingPage.vue","LoadingPage.vue"],"names":[],"mappings":"AA4BA;EACA,aAAA;EACA,wCAAA;EACA,0BAAA;EACA,uCAAA;EACA,YAAA;EACA,YAAA;AC3BA;ADwDA;AAnCA;IASA,WAAA;IACA,6CAAA;IACA,4DACA;AC3BE;AACF;AD+BA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EC5BE,iCAAiC;AACnC;AD0BA;AANA;IAWA,wBAAA;AC3BE;AACF;ADiCA;AAlBA;IAeA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,mBArCA;ACWE;AACF;AD6BA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AC1BA;ADYA;AAUA;IAOA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,MAAA;IACA,4BAAA;IACA,UAAA;ACzBE;AACF;ADOA;AAIA;IAiBA,cAAA;IACA,qBAAA;IACA,gBAAA;IACA,mBAAA;IACA,oBA9DA;ACsCE;AACF;AD2BA;EACA,aAAA;EACA,mBAAA;ACxBA;AD2BA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;ACxBA;ADbA;AAkCA;IAMA,aAAA;ACvBE;AACF;;AAEA,0CAA0C","file":"LoadingPage.vue","sourcesContent":["<template lang='pug'>\n.p-wrapper\n  header.p-header\n    h1.is-title-2.p-title\n      img.c-logo(\n        src='/assets/images/group-income-icon-transparent.png'\n        alt=''\n      )\n      | {{$route.meta.title}}\n\n  main.p-main\n    .loading-box\n    .loading-box\n    .loading-box\n</template>\n\n<script>\nexport default ({\n  name: 'LoadingPage'\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n$pagePadding: 1rem;\n$pagePaddingDesktop: 5.5rem;\n\n.p-wrapper {\n  display: grid;\n  grid-template-areas: \"p-header\" \"p-main\";\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  width: 100vw;\n\n  @include desktop {\n    width: auto;\n    grid-template-columns: minmax(0, 1fr) $rightSideWidth;\n    grid-template-areas:\n      \"p-header p-sidebar\"\n      \"p-main p-sidebar\";\n  }\n}\n\n.p-main {\n  grid-area: p-main;\n  width: calc(100% - 2rem);\n  margin: 0 auto;\n  padding-top: 1.5rem;\n  max-width: 50rem;\n  display: flex;\n  flex-direction: column;\n  @include overflow-touch;\n\n  @include tablet {\n    width: calc(100% - 4rem);\n  }\n\n  @include desktop {\n    width: auto;\n    padding-top: 0;\n    margin-right: 2rem;\n    margin-left: $pagePaddingDesktop;\n  }\n}\n\n.p-header {\n  grid-area: p-header;\n  transition: padding ease-out 300ms;\n  text-align: center;\n  min-height: 4rem;\n\n  @include touch {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    background: $general_2;\n    z-index: 3;\n  }\n\n  @include desktop {\n    display: block;\n    padding-top: 1.125rem;\n    text-align: left;\n    min-height: 4.75rem;\n    padding-left: $pagePaddingDesktop;\n  }\n}\n\n.p-title {\n  display: flex;\n  align-items: center;\n}\n\n.c-logo {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 1rem;\n\n  @include desktop {\n    display: none;\n  }\n}\n</style>\n",".p-wrapper {\n  display: grid;\n  grid-template-areas: \"p-header\" \"p-main\";\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  width: 100vw;\n}\n@media screen and (min-width: 1200px) {\n  .p-wrapper {\n    width: auto;\n    grid-template-columns: minmax(0, 1fr) 16.5rem;\n    grid-template-areas: \"p-header p-sidebar\" \"p-main p-sidebar\";\n  }\n}\n\n.p-main {\n  grid-area: p-main;\n  width: calc(100% - 2rem);\n  margin: 0 auto;\n  padding-top: 1.5rem;\n  max-width: 50rem;\n  display: flex;\n  flex-direction: column;\n  -webkit-overflow-scrolling: touch;\n}\n@media screen and (min-width: 769px), print {\n  .p-main {\n    width: calc(100% - 4rem);\n  }\n}\n@media screen and (min-width: 1200px) {\n  .p-main {\n    width: auto;\n    padding-top: 0;\n    margin-right: 2rem;\n    margin-left: 5.5rem;\n  }\n}\n\n.p-header {\n  grid-area: p-header;\n  transition: padding ease-out 300ms;\n  text-align: center;\n  min-height: 4rem;\n}\n@media screen and (max-width: 1199px) {\n  .p-header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    background: var(--general_2);\n    z-index: 3;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .p-header {\n    display: block;\n    padding-top: 1.125rem;\n    text-align: left;\n    min-height: 4.75rem;\n    padding-left: 5.5rem;\n  }\n}\n\n.p-title {\n  display: flex;\n  align-items: center;\n}\n\n.c-logo {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 1rem;\n}\n@media screen and (min-width: 1200px) {\n  .c-logo {\n    display: none;\n  }\n}\n\n/*# sourceMappingURL=LoadingPage.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-b4e9b596"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n.p-wrapper\n  header.p-header\n    h1.is-title-2.p-title\n      img.c-logo(\n        src='/assets/images/group-income-icon-transparent.png'\n        alt=''\n      )\n      | {{$route.meta.title}}\n\n  main.p-main\n    .loading-box\n    .loading-box\n    .loading-box\n</template>\n\n<script>\nexport default ({\n  name: 'LoadingPage'\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n$pagePadding: 1rem;\n$pagePaddingDesktop: 5.5rem;\n\n.p-wrapper {\n  display: grid;\n  grid-template-areas: \"p-header\" \"p-main\";\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  width: 100vw;\n\n  @include desktop {\n    width: auto;\n    grid-template-columns: minmax(0, 1fr) $rightSideWidth;\n    grid-template-areas:\n      \"p-header p-sidebar\"\n      \"p-main p-sidebar\";\n  }\n}\n\n.p-main {\n  grid-area: p-main;\n  width: calc(100% - 2rem);\n  margin: 0 auto;\n  padding-top: 1.5rem;\n  max-width: 50rem;\n  display: flex;\n  flex-direction: column;\n  @include overflow-touch;\n\n  @include tablet {\n    width: calc(100% - 4rem);\n  }\n\n  @include desktop {\n    width: auto;\n    padding-top: 0;\n    margin-right: 2rem;\n    margin-left: $pagePaddingDesktop;\n  }\n}\n\n.p-header {\n  grid-area: p-header;\n  transition: padding ease-out 300ms;\n  text-align: center;\n  min-height: 4rem;\n\n  @include touch {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    background: $general_2;\n    z-index: 3;\n  }\n\n  @include desktop {\n    display: block;\n    padding-top: 1.125rem;\n    text-align: left;\n    min-height: 4.75rem;\n    padding-left: $pagePaddingDesktop;\n  }\n}\n\n.p-title {\n  display: flex;\n  align-items: center;\n}\n\n.c-logo {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-right: 1rem;\n\n  @include desktop {\n    display: none;\n  }\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__